<mat-drawer-container class="d-flex h-100 w-100" >
    <mat-drawer-content class="d-flex h-100 w-100 overflow-hidden">
     <div class="d-flex flex-column mat-content h-100 w-100">
        <div class="d-flex flex-row h-100 w-100">
            <div class="d-none d-md-block side-nav-shell" *ngIf="!isLoginPage() && loggedIn && !isLIC">
             <cva-side-nav></cva-side-nav>
            </div>
            <div class="content-wrapper flex-grow-1 w-100 h-100 overflow-auto overflow-x-hidden">
              <cva-notification-banner></cva-notification-banner>
              <div class="router-outlet-content h-100 w-100">
                <router-outlet></router-outlet>
              </div>
              <cva-copyright></cva-copyright>
            </div>
          </div>
          <div class="bottom-nav d-md-none d-sm-block" *ngIf="!isLoginPage() && loggedIn && !isLIC">
            <cva-bottom-nav></cva-bottom-nav>
          </div>
     </div>
    </mat-drawer-content>
</mat-drawer-container>

<ng-http-loader *ngIf="shouldShowGlobalLoader()" [filteredUrlPatterns]="LOADER_EXCLUSION_ENDPOINTS"
  [entryComponent]="globalHttpLoaderComponent" [backdrop]="true" [opacity]="'1'"
  [backdropBackgroundColor]="'rgba(241, 245, 255, 0.68)'" [minDuration]="250" [debounceDelay]="120">
</ng-http-loader>
